import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from '../components/ui/dialog';
import { ScrollArea } from '../components/ui/scroll-area';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const FAQModal = ({ isOpen, onClose }) => {
    const faqData = [
        {
            question: "What is Iraga Digital Membership?",
            answer: "Iraga Digital membership is a digital-based loyalty program that provides registered members with exclusive rewards, promotions, and updates from Iraga Coffee & Roastery."
        },
        {
            question: "How do I join the membership?",
            answer: "You can register directly through our website."
        },
        {
            question: "Is there a physical membership card?",
            answer: "No. This membership is fully digital and accessible via your mobile device."
        },
        {
            question: "How do I earn rewards?",
            answer: "Members earn reward points from eligible purchases made at Iraga Coffee & Roastery, in accordance with the applicable program terms."
        },
        {
            question: "Does the membership expire?",
            answer: "Membership validity and reward terms may vary. Please refer to the latest terms and conditions available through our official channels."
        }
    ];

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl w-[90vw] md:w-full max-h-[85vh] p-0 overflow-hidden bg-white text-[#31415A] border-none shadow-2xl rounded-2xl">
                <DialogClose className="absolute right-4 top-4 z-50 text-white hover:text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </DialogClose>
                <DialogHeader className="p-6 md:p-8 pb-4 bg-[#31415A] text-white">
                    <DialogTitle className="text-2xl md:text-3xl font-bold text-center mt-2">Frequently Asked Questions</DialogTitle>
                    <DialogDescription className="text-center text-gray-300">
                        Everything you need to know about our membership
                    </DialogDescription>
                </DialogHeader>

                <ScrollArea className="h-full p-6 md:p-8 pt-2">
                    <Accordion type="single" collapsible className="w-full space-y-4">
                        {faqData.map((faq, index) => (
                            <AccordionItem key={index} value={`item-${index}`} className="border rounded-lg px-4 bg-gray-50 border-gray-100 data-[state=open]:bg-blue-50/50 data-[state=open]:border-blue-100 transition-all duration-200">
                                <AccordionTrigger className="text-left font-bold text-lg text-[#31415A] hover:no-underline py-4">
                                    {faq.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-gray-600 text-base leading-relaxed pb-4">
                                    {faq.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <div className="mt-8 text-center text-sm text-gray-400">
                        <p>Still have questions? Contact us at iragacoffee@gmail.com</p>
                    </div>
                </ScrollArea>
            </DialogContent>
        </Dialog>
    );
};

export default FAQModal;
